import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Row, Col } from 'reactstrap';
import { TooltipItem } from 'site-modules/shared/components/tooltip-item/tooltip-item';

import './calculator-row-item.scss';

const getResultColumnProps = overrideWrapperClass => ({
  WRAPPER_CLASS: overrideWrapperClass ? '' : 'mb-1',
  LEFT_COL_SIZES: {
    xs: 6,
  },
  RIGHT_COL_SIZES: {
    xs: 6,
  },
  RIGHT_COL_CLASS: 'me-auto text-end align-self-center',
});

const getInputColumnProps = overrideWrapperClass => ({
  WRAPPER_CLASS: overrideWrapperClass ? '' : 'mb-1_5',
  LEFT_COL_SIZES: {
    xs: 12,
    md: 7,
  },
  RIGHT_COL_SIZES: {
    xs: 12,
    md: 5,
  },
  RIGHT_COL_CLASS: 'me-auto text-md-end align-self-center',
});

/**
 * Renders row item (left side is title w/ or w/o subtitle, tooltip and right side is children)
 * @param {node[]|node|string} children
 * @param {string} title
 * @param {string} subtitle
 * @param {object} tooltip
 * @param {boolean} isResultCalculations
 * @returns {ReactElement}
 */
export function CalculatorRowItem({
  children,
  title,
  subtitle = '',
  tooltip = null,
  isResultCalculations = false,
  wrapperClass = '',
  TitleWrapper = Fragment,
  overrideWrapperClass = false,
}) {
  const { WRAPPER_CLASS, LEFT_COL_SIZES, RIGHT_COL_SIZES, RIGHT_COL_CLASS } = isResultCalculations
    ? getResultColumnProps(overrideWrapperClass)
    : getInputColumnProps(overrideWrapperClass);
  return (
    <Row className={classNames('calculator-row-item', WRAPPER_CLASS, wrapperClass)}>
      <Col {...LEFT_COL_SIZES} className="text-gray-darker mb-0_5 mb-md-0 align-self-center">
        <TitleWrapper>{title}</TitleWrapper>
        {tooltip && (
          <TooltipItem
            id={title.replace(/\s/g, '').replace(/&/g, 'and')}
            item={tooltip}
            className="text-gray-darker ps-0_25"
            iconClassName="px-0_5 pt-0_5 pb-0 p-md-0"
          />
        )}
        {!!subtitle && <div className="small text-gray-darker">{subtitle}</div>}
      </Col>
      <Col {...RIGHT_COL_SIZES} className={RIGHT_COL_CLASS}>
        {children}
      </Col>
    </Row>
  );
}

CalculatorRowItem.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node, PropTypes.string]).isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node, PropTypes.string]),
  isResultCalculations: PropTypes.bool,
  tooltip: PropTypes.shape({
    text: PropTypes.string,
    placement: PropTypes.string,
  }),
  wrapperClass: PropTypes.string,
  TitleWrapper: PropTypes.node,
  overrideWrapperClass: PropTypes.bool,
};
